import { render, staticRenderFns } from "./KPIView.vue?vue&type=template&id=06ee8662&"
import script from "./KPIView.vue?vue&type=script&lang=ts&"
export * from "./KPIView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports